import config from '~/config';

export const formatShortHumanMonth = (date: Date, includeYear = true, locale: string[] = config.locale) =>
	Intl.DateTimeFormat(locale, {
		month: 'short',
		year: includeYear ? 'numeric' : undefined,
	})
		.format(date)
		.replace(/ /g, '\xA0');
